import React from 'react';
import { motion } from 'framer-motion';
import { useLang } from '@/context/LanguageContext';

export const Intro = () => {
  const { t } = useLang();

  return (
    <section
      id="intro"
      data-testid="intro-band"
      className="relative overflow-hidden bg-[var(--cea-lamp-red)] text-white"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="space-y-5"
        >
          <p
            data-testid="intro-p1"
            className="font-display font-medium uppercase tracking-wide text-2xl sm:text-3xl lg:text-4xl leading-[1.05]"
          >
            {t.intro.p1}
          </p>
          <p data-testid="intro-p2" className="text-base sm:text-lg text-white/90 leading-relaxed max-w-3xl">
            {t.intro.p2}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
